var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var TabTable = (function (_super) {
    __extends(TabTable, _super);
    function TabTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabTable.prototype.selectionChange = function (rows, row) {
        this.$emit('selectChange', rows, row);
        console.log(rows, row);
    };
    TabTable.prototype.selectAll = function (rows) {
        this.$emit('selectChange', rows, null, true);
    };
    TabTable.prototype.cellClass = function (row) {
        if (row.columnIndex === 0) {
            return 'DisableSelection';
        }
    };
    TabTable.prototype.checkMaterialStatus = function (row) {
        if (this.target.goods_format_id === row.goods_format_id ||
            (this.selectList && this.selectList.length == 1)) {
            return false;
        }
        else {
            return true;
        }
    };
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], TabTable.prototype, "data", void 0);
    __decorate([
        Prop({
            required: false,
            type: Object
        })
    ], TabTable.prototype, "target", void 0);
    __decorate([
        Prop({
            required: false,
            type: Number
        })
    ], TabTable.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], TabTable.prototype, "selectList", void 0);
    TabTable = __decorate([
        Component
    ], TabTable);
    return TabTable;
}(Vue));
export default TabTable;
